import { EGEM } from '../types';
export default {
  type: EGEM,
  service: 'egem.io',
  url: 'https://jsonrpc.egem.io/custom',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
